import { CompanyAction } from 'app/utils/companyDux';
import { ArcadeListItem } from 'routes/arcades/interfaces';
import { AugmentedRoom, TokenBuilderFormFields, ValidationState } from './interfaces';

export enum ActionTypes {
    SET_ARCADE_LIST = 'TOKEN_BUILDER__SET_ARCADE_LIST',
    SET_FORM_FIELDS = 'TOKEN_BUILDER__SET_FORM_FIELDS',
    SET_RECOGNITION_DISTRIBUTION_SELECTION = 'SET_RECOGNITION_DISTRIBUTION_SELECTION',
    SET_VALIDATION_ERRORS = 'TOKEN_BUILDER__SET_VALIDATION_ERRORS',
}

export interface LoadArcadeListAction extends CompanyAction<ActionTypes.SET_ARCADE_LIST> {
    arcadeList: ArcadeListItem[];
    roomList: AugmentedRoom[];
}

export interface SetFormFieldAction extends CompanyAction<ActionTypes.SET_FORM_FIELDS> {
    // There's no way to flatten-out this wrapper object without breaking Typescript's ability to
    // understand this part of a tagged union.
    //
    // We can't just write "[P in keyof TokenBuilderFormFields]?: T[P]" instead because interfaces
    // can't have calculated field names. If we try to define `SetFormFieldAction` as the intersection
    // of Action<...> and Partial<...>, suddenly Typescript stops verifying that we're typing in real
    // fields.
    fields: Partial<TokenBuilderFormFields>;
}

export interface SetRecognitionDistributionsAction extends CompanyAction<ActionTypes.SET_RECOGNITION_DISTRIBUTION_SELECTION> {
    recognitionDistributionId: string;
    value: boolean;
}

export interface SetValidationErrorsAction extends CompanyAction<ActionTypes.SET_VALIDATION_ERRORS> {
    validationErrors: ValidationState;
}

export type TokenBuilderAction = LoadArcadeListAction
    | SetFormFieldAction
    | SetRecognitionDistributionsAction
    | SetValidationErrorsAction
;
